import {
  validateEmail 
} from "@/util/formValidators"
import mergeOperations from "@/util/shallowMerge"
import {
  useMutation 
} from "@apollo/client"
import {
  useCallback, useMemo, useState 
} from "react"
import DEFAULT_OPERATIONS from "./newsletter.gql"

export const useNewsletter = (props = {}) => {
  const {
    subscribeMutation, getStoreConfigQuery 
  } = mergeOperations(
    DEFAULT_OPERATIONS,
    props.operations
  )

  const [newsLetterError, setNewsLetterError] = useState(null)

  const [isModalOpen, setIsModalOpen] = useState(false)

  const [subscribeNewsLetter, {
    data, loading: subscribeLoading 
  }] =
        useMutation(subscribeMutation, {
          fetchPolicy: "no-cache",
          onError: setNewsLetterError,
        })

  const handleSubmit = useCallback(
    async (data) => {
      const {
        email 
      } = data

      if (!email || validateEmail(email)) {
        return
      }

      try {
        await subscribeNewsLetter({
          variables: {
            email 
          },
        })

        if (formApiRef.current) {
          formApiRef.current.reset()
        }
      } catch (error) {
        if (process.env.NODE_ENV !== "production") {
          console.error(error)
        }
      }
    },
    [subscribeNewsLetter]
  )

  const errors = useMemo(
    () => new Map([["subscribeMutation", newsLetterError]]),
    [newsLetterError]
  )

  return {
    errors,
    handleSubmit,
    isBusy: subscribeLoading,
    newsLetterResponse: data && data.subscribeEmailToNewsletter,
    isModalOpen,
    setIsModalOpen,
  }
}
